import { message, Select } from 'antd'
import Quotes from '../../../../api/Sales/Quotes'
import { get, isEmpty, omit, pick, set } from 'lodash'
import { sessionItem } from '../../../../modules/Utils'
import qs from 'query-string'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import DocumentsApi from '../../../../api/Documents'
import Clients from '../../../../api/Sales/Clients'
import OrdersApi from '../../../../api/Sales/Orders'
import withMapList from '../../../../elements/HOC/withMapList'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../elements/HOC/withSubDropdown'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { execute, idMaker, normalizeDateTimeToDate, strVal } from '../../../../modules/Utils'
import AddOrder from './AddOrder'

class AddOrderCont extends Component {
  docsApi = new DocumentsApi()
  state = {
    submitting: false,
    fetchingQuote: false,
    visibleLine: false,
    ServicesSelectCmp: Select,
    ContractsSelectCmp: Select,
    GroupsSelect: Select,
    CategorySelect: Select,
    FileSelectCmp: Select,
    lines: [],
    actions: [],
    line: { booking: { destinations: [] } },
    order: {},
    quote: {},
    modalType: 'new',
    type: 'new',
    fetching: false,
  }
  api = new OrdersApi()
  clientApi = new Clients()
  formRef = React.createRef()
  invoiceFormRef = React.createRef()
  serviceSelectRef = React.createRef()
  lineFormRef = React.createRef()
  ids = idMaker()
  quoteApi = new Quotes()

  constructor(props) {
    super(props)
    this.key = get(props.match, 'params.key')
    const values = qs.parse(props.location.search)
    this.enquiryID = values.enquiryID
  }

  async componentDidMount() {
    if (!isEmpty(this.key)) {
      this.fetch()
      this.fetchLines()
    }
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const order = await this.api.read(this.key)
      this.onChangeCompany(order.company._id)
      order.client && this.onChangeClient(order.client._id)
      this.onChangeContract(order.contract._id)
      const FileSelectCmp = compose(
        withUrlFetch({
          name: `${order._id}_files`,
          url: `files/?folder=${order._id}`,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      const actions = await this.docsApi.actions('bookings', order.status)
      this.setState({
        type: 'edit',
        order,
        actions,
        FileSelectCmp,
        fetching: false,
      })
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
    }
  }

  fetchLines = async () => {
    this.setState({
      fetchingLines: true,
    })
    const lines = await this.api.lines.list(this.key)
    this.setState({
      lines: lines,
      fetchingLines: false,
    })
  }

  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (this.state.lines.length > 0) {
            normalizeDateTimeToDate(values, 'date')
            normalizeDateTimeToDate(values, 'cpo.date')
            this.setState({
              order: Object.assign({}, this.state.order, values),
            })
            res(true)
          } else message.error('Empty lines')
        }
      })
    })
  }

  checkLineForm = () => {
    return new Promise((res, rej) => {
      this.lineFormRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log({ values })
          normalizeDateTimeToDate(values, 'booking.pickup.date')
          normalizeDateTimeToDate(values, 'booking.dropoff.date')
          set(values, 'booking.destinations', get(this, 'state.line.booking.destinations'))
          res(Object.assign({}, this.state.line, values))
        }
      })
    })
  }

  removeLine = async (key) => {
    if (this.state.type === 'new') {
      let newData = [...this.state.lines]
      newData = newData.filter((item) => key !== item.key)
      this.setState({ lines: newData })
      this.onCancelLine()
    } else {
      try {
        const line = this.state.lines.find((b) => b._id === key)
        this.setState({
          removingLine: true,
        })
        await this.api.lines.remove(pick(line, ['_key', '_id', '_rev']))
        this.setState({
          removingLine: false,
        })
        this.onCancelLine()
        await this.fetchLines()
      } catch (e) {
        this.setState({
          removingLine: false,
        })
        message.error(e.errorMessage)
      }
    }
  }

  addDestination = () => {
    this.setState((prevState) => {
      const line = { ...prevState.line }
      const newDestinations = [...line.booking.destinations, { key: this.ids.next().value }]
      set(line, 'booking.destinations', newDestinations)
      return { line }
    })
  }

  removeDestination = (key) => {
    this.setState((prevState) => {
      const line = { ...prevState.line }
      const newDestinations = line.destinations.filter((d) => d.key !== key)
      set(line, 'booking.destinations', newDestinations)
      return { line }
    })
  }

  submit = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      const { lines } = this.state
      lines.forEach((b) => {
        b.contract = this.state.order.contract
      })

      if (lines.length < 1) {
        message.error('No Lines Found')
        return
      }
      const submitted = await this.api.createWithLines({
        salesOrder: {
          quote: pick(this.state.quote, ['_id', '_rev', 'code', 'date', 'validityEnd']),
          ...pick(this.state.order, [
            'centers',
            'client',
            'clientRep',
            'company',
            'companyRep',
            'contract',
            'cpo',
            'dangerousGoods',
            'date',
            'taxType',
            'tax',
            'delivery',
            'enquiry',
            'isDangerous',
            'isDelivery',
            'isRestricted',
            'notify',
            'orderType',
            'paymentTerms',
            'reference',
            'title',
          ]),
        },
        lines: lines.map((b) => omit(b, ['key', 'enquiryLines', 'rfqLine', 'rfq'])),
      })
      this.setState({
        submitting: false,
      })

      this.props.history.push({
        pathname: `/clients/orders/${submitted._key}/update`,
      })
      window.location.reload()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }

  update = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      const order = await this.api.update(
        omit(this.state.order, [
          'code',
          'status',
          'revision',
          'type',
          '_history',
          'billing',
          'subtotal',
          'center',
          'enquirerRep',
        ])
      )
      this.setState({
        submitting: false,
        order,
      })
      message.success('Updated!')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }

  handleLocationChange = (type, location) => {
    const line = { ...this.state.line }
    set(line, type, location)
    this.setState({
      line: line,
    })
  }

  onChangeDestinations = (key, value, attribute) => {
    this.setState((prevState) => {
      const line = { ...prevState.line }
      const des = line.booking.destinations.find((d) => d.key === key)
      set(des, attribute, value)
      return { line }
    })
  }

  onShowLine = () => {
    this.setState({
      visibleLine: true,
      line: { booking: { destinations: [] } },
      modalType: 'new',
    })
  }

  onShowInvoice = () => {
    console.log(this.state.lines)
    this.setState((prvState) => ({
      visibleInvoice: true,
      invoice: {},
      billLines: prvState.lines,
    }))
  }

  onShowEditLine = async (e, line) => {
    // console.log({line})
    await this.onChangeProductCategory(get(line, 'product.category._id'))
    await this.onChangeProductGroup(get(line, 'product.group._id'))
    this.setState({
      visibleLine: true,
      line,
      modalType: 'edit',
    })
  }

  onCancelLine = () => {
    this.setState({
      visibleLine: false,
    })
  }

  onCancelInvoice = () => {
    this.setState({
      visibleInvoice: false,
    })
    this.fetchLines()
  }

  updateLine = async () => {
    console.log('updateLine')
    const values = await this.checkLineForm()
    console.log(111, { values })
    if (this.state.type === 'new') {
      const { lines, productsURL } = { ...this.state }
      values.product = sessionItem(`products_${productsURL}_dropdown`, get(values, 'product._id'), '_id')
      values.unit = values.unit || 1
      let nt = Math.round(values.unit * values.rate * 100) / 100
      values.amount = {
        gross: Math.round(nt * 100) / 100,
        tax: 0,
        net: nt,
      }
      let bookingIndex = lines.findIndex((b) => b.key === values.key)
      lines.splice(bookingIndex, 1, values)
      const newLines = [...lines]
      this.setState({ lines: newLines, visibleLine: false })
    } else {
      console.log('in')
      try {
        this.setState({
          updatingBooking: true,
        })
        await this.api.lines.update(omit(values, ['order', 'contract', 'invoiced', 'amount', 'type']))
        this.setState({
          updatingBooking: false,
        })
        this.onCancelLine()
        await this.fetch()
        await this.fetchLines()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({
          updatingBooking: false,
        })
      }
    }
  }

  submitLine = async () => {
    const values = await this.checkLineForm()
    if (this.state.type === 'new') {
      const { lines, productsURL } = { ...this.state }
      values.key = this.ids.next().value
      values.order = { _id: 'temp' }
      values.product = sessionItem(`products_${productsURL}_dropdown`, get(values, 'product._id'), '_id')
      values.unit = values.unit || 1
      let nt = Math.round(values.unit * values.rate * 100) / 100
      values.amount = {
        gross: Math.round(nt * 100) / 100,
        tax: 0,
        net: nt,
      }
      const newBooking = [...lines, values]
      this.setState({ lines: newBooking, visibleLine: false })
    } else {
      try {
        this.setState({
          updatingBooking: true,
        })
        values.contract = this.state.order.contract
        values.order = pick(this.state.order, ['_id', '_rev', 'code'])
        const { order, line } = await this.api.lines.add(values)
        this.setState((prvState) => ({
          updatingBooking: false,
          order,
          lines: [...prvState.lines, line],
        }))
        this.onCancelLine()
        // await this.fetchLines()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({
          updatingBooking: false,
        })
      }
    }
  }

  onChangeCompany = (company) => {
    this.setState({ company })
  }
  onChangeProductType = (productType) => {
    const categoriesURL = `products/categories/dropdown?type=${productType}&owner=${this.state.company}&select=*`
    this.url = categoriesURL
    const CategorySelect = compose(
      withUrlFetch({
        name: 'products_categories',
        url: categoriesURL,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.setState({ CategorySelect })
  }

  onChangeProductCategory = (category) => {
    const url = `products/groups/dropdown` + `?owner=${this.state.company}&category=${category}` + '&select=*'
    this.url = url
    const GroupsSelect = compose(
      withUrlFetch({
        name: 'products_groups',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.lineFormRef.current && this.lineFormRef.current.resetFields(['group._id'])
    this.setState({ category, GroupsSelect })
  }

  onChangeProductGroup = (group) => {
    const url =
      `products/` +
      `?owner=${this.state.company}&state=Active&category=${this.state.category}&group=${group}` +
      '&select=*'
    this.url = url
    const ProductsSelect = compose(
      withUrlFetch({
        name: 'products',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withMapList(({ name, ...product }) => ({
        name: `${name} - ${strVal(product, 'description')}`,
        ...product,
      })),
      withSort
    )(CustomSelect)
    this.lineFormRef.current && this.lineFormRef.current.resetFields(['product._id'])
    this.setState({ productsURL: url, ProductsSelect })
  }

  onChangeClient = (client) => {
    this.formRef.current && this.formRef.current.resetFields(['contract._id'])
    if (!isEmpty(client)) {
      const owner = client.replace('partners/', '')
      const { company } = this.state
      const url = `clients/` + (isEmpty(owner) ? '' : `${owner}`) + `/contracts?company=${company}&state=active`
      const ContractsSelectCmp = compose(
        withUrlFetch({
          name: 'clients_contracts',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.setState({ client, ContractsSelectCmp })
    } else {
      this.setState({
        client: '',
        ContractsSelectCmp: Select,
        url: '',
      })
    }
  }

  onChangeContract = (contract) => {
    if (!isEmpty(contract)) {
      const ServicesSelectCmp = compose(
        withUrlFetch({
          name: 'clients',
          url: contract,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSubDropdown({ name: 'rates' }),
        withMapList(({ name, ...r }) => ({
          name: `${strVal(r, 'product.name')} / ${name}`,
          ...r,
        })),
        withSort
      )(CustomSelect)
      let company = ''
      if (this.formRef.current) {
        company = this.formRef.current.getFieldValue('company._id')
      }
      const url = `products/categories/dropdown` + `?owner=${company}` + '&select=*'
      const CategorySelect = compose(
        withUrlFetch({
          name: 'products_categories',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.setState({ contract, company, CategorySelect, ServicesSelectCmp })
    } else {
      this.setState({
        ServicesSelectCmp: Select,
      })
    }
  }

  onChangeQuote = async (quoteID) => {
    console.log({ quoteID })
    if (!quoteID) {
      this.setState({
        quote: {},
      })
    } else {
      try {
        this.setState({ fetchingQuote: true, quote: { _id: quoteID } })
        const { order } = this.state
        const quote = await this.quoteApi.read(strVal({ quoteID }, 'quoteID').replace('quotes/', ''))
        await this.onChangeCompany(get(quote, 'company._id'))
        await this.onChangeClient(get(quote, 'enquirer._id'))
        const data = {
          quote,
          lines: quote.lines.map((ql) => ({
            order: { _id: 'temp' },
            quoteLine: pick(ql, '_id', 'name', 'quote'),
            isShippable: true,
            key: ql._key,
            ...omit(ql, ['uuid', 'type', '_key', '_id', 'quote', 'uploaded', 'ref']),
            rate: get(ql, 'rate') || 0,
            tax: {percentage: get(ql, 'tax.percentage') || 0, rate: get(ql, 'tax.rate') || 0, type: get(ql, 'tax.type') || 'N/A'},
            uom: { code: get(ql, 'uom.code') || get(ql, 'uom') },
            amount: { gross:  get(ql, 'amount.gross') || 0, net: get(ql, 'amount.net') || 0, tax: get(ql, 'amount.tax') || 0},
          })),
          order: {
            ...order,
            ...omit(quote, ['_key', '_id', '_rev', 'code', 'status', 'uploaded', 'ref']),
            quote: pick(quote, ['_id', 'code']),
            isExistingClient: get(quote, ['isExistingClient']),
            client: { member: get(quote, 'enquirer') },
            clientRep: get(quote, 'enquirerRep'),
            enquiry: get(quote, 'enquiry'),
            orderType: quote.quoteType,
          },
          fetchingQuote: false,
        }
        set(data, 'order.cpo.currency', get(quote, 'currency'))

        this.setState(data)
      } catch (e) {
        console.error(e)
        this.setState({ fetchingQuote: false })
      }
    }
  }

  handleOps = async (operation, order) => {
    console.log(operation)
    const { remove } = this.api
    const { history } = this.props
    let hide = () => console.error('Not Found')
    switch (operation) {
      case 'submit':
        hide = message.loading('Submitting...', 0)
        try {
          const orderDB = await this.api.operation('submit', pick(order, ['_key', '_rev', '_id']))
          const actions = await this.docsApi.actions('bookings', orderDB.status)
          this.setState({
            order: orderDB,
            actions,
          })
          message.success('Success')
          hide()
        } catch (e) {
          hide()
          message.error(e.errorMessage)
        }
        break
      case 'approve':
        hide = message.loading('Approving...', 0)
        try {
          const orderDB = await this.api.operation('approve', pick(order, ['_key', '_rev', '_id']))
          const actions = await this.docsApi.actions('bookings', orderDB.status)
          this.setState({
            order: orderDB,
            actions,
          })
          message.success('Success')
          hide()
        } catch (e) {
          hide()
          message.error(e.errorMessage)
        }
        break
      case 'hold':
        hide = message.loading('Holding...', 0)
        try {
          const orderDB = await this.api.operation('hold', pick(order, ['_key', '_rev', '_id']))
          const actions = await this.docsApi.actions('bookings', orderDB.status)
          this.setState({
            order: orderDB,
            actions,
          })
          message.success('Success')
          hide()
        } catch (e) {
          hide()
          message.error(e.errorMessage)
        }
        break
      case 'cancel':
        await execute(this, this.api.operation.bind(this, 'cancel', pick(order, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'revise':
        hide = message.loading('Revising...', 0)
        try {
          const orderDB = await this.api.operation('revise', pick(order, ['_key', '_rev', '_id']))
          const actions = await this.docsApi.actions('bookings', orderDB.status)
          this.setState({
            order: orderDB,
            actions,
          })
          message.success('Success')
          hide()
        } catch (e) {
          hide()
          message.error(e.errorMessage)
        }
        break
      case 'remove':
        hide = message.loading('Removing...', 0)
        try {
          await remove(pick(order, ['_key', '_rev', '_id']))
          hide()
          history.replace({
            pathname: `/clients/orders/`,
          })
        } catch (e) {
          hide()
          message.error(e.errorMessage)
        }
        return
      case 'close':
        hide = message.loading('Closing...', 0)
        try {
          const orderDB = await this.api.operation('close', pick(order, ['_key', '_rev', '_id']))
          const actions = await this.docsApi.actions('bookings', orderDB.status)
          this.setState({
            order: orderDB,
            actions,
          })
          hide()
        } catch (e) {
          hide()
          message.error(e.errorMessage)
        }
        break
    }
    this.fetch()
  }

  render() {
    // console.log(this.enquiryID)
    return (
      <AddOrder
        {...this.state}
        {...pick(this, [
          'fetchLines',
          'submit',
          'update',
          'fetch',
          'handleLocationChange',
          'onChangeProductType',
          'handleOps',
          'onShowLine',
          'onShowInvoice',
          'onCancelInvoice',
          'updateLine',
          'onShowEditLine',
          'onCancelLine',
          'removeLine',
          'addDestination',
          'removeDestination',
          'submitLine',
          'onChangeCompany',
          'onChangeContract',
          'onChangeClient',
          'onChangeLineUOM',
          'onChangeDestinations',
          'onChangeProductCategory',
          'onChangeProductGroup',
          'onChangeQuote',
          'formRef',
          'lineFormRef',
          'serviceSelectRef',
          'invoiceFormRef',
        ])}
      />
    )
  }
}

AddOrderCont.propTypes = {}
AddOrderCont.defaultProps = {}

export default compose(withRouter)(AddOrderCont)
